import React from 'react';
import tabImageIconMap from '../../../helpers/MyDataHelps/tabIconImageMap';

export interface TabIconProps {
    tabTitle: string
    systemItem?: string | null
    image?: string | null
    encodedImage?: string | null
}

const systemItemIcons: { [key: string]: string } = {
    "More": "ellipsis-h",
    "Favorites": "star",
    "Featured": "star",
    "TopRated": "star",
    "Recents": "clock",
    "Contacts": "users",
    "History": "clock",
    "Bookmarks": "book-open",
    "Search": "search",
    "Downloads": "download",
    "MostRecent": "clock",
    "MostViewed": "list-alt",
};

export default function (props: TabIconProps) {
    function iconForTab() {
        if (props.systemItem && props.systemItem != "Custom") {
            return systemItemIcons[props.systemItem];
        }

        if (props.image && tabImageIconMap[props.image]) {
            return tabImageIconMap[props.image];
        }
        return "ellipsis-h";
    }

    return <div className="tab-icon">
        {props.encodedImage && <img src={`data:image/png;base64,${props.encodedImage}`} alt={props.tabTitle} />}
        {!props.encodedImage && <i className={`fa fa-${iconForTab()}`} />}
    </div>
}